import { createSelector } from 'reselect';

import { editorSelector } from 'modules/v2/editor/store/selectors/editor';

export const toolbarSelector = createSelector(editorSelector, (editor) => editor.toolbar);
